import React, { Component } from 'react';

import Blank from '../../../hoc/Blank/Blank';
import Button from '../../UI/Button/Button';

class AddDriverErrorModal extends Component {
    render () {
        return (
            <Blank>
                <h3>Admin Driver Error</h3>
                <p>Please Check over the form.
                <br />At a minimum you need:
                </p>
                <ul>
                    <li>First Name</li>
                    <li>Last Name</li>
                    <li>Unique Phone Number</li>
                    <li>Number of Bags</li>
                </ul>
                <Button btnType="Danger" clicked={this.props.modalClosed}>CANCEL</Button>
            </Blank>
        );
    }
}

export default AddDriverErrorModal;


// WEBPACK FOOTER //
// ./src/components/ErrorModals/AddDriverErrorModal/AddDriverErrorModal.js